import { apiGet } from '../services/apiClient';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    qs.set(key, String(value));
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

export const listPublicBlogs = (params) => apiGet(`/api/public/content/blogs${buildQuery(params)}`);
export const getPublicBlogBySlug = (slug) => apiGet(`/api/public/content/blogs/${encodeURIComponent(slug)}`);
